import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { Procedure } from 'types/procedure';

type ProcedureItemModuleProps = {
  procedure: Procedure;
};

const ProcedureItemModule: React.FC<ProcedureItemModuleProps> = ({ procedure }) => {
  return (
    <ModuleCard
      title={procedure.name}
      subtitle={procedure.formattedSpecialties}
      status={procedure.formattedActive}
      statusTone={procedure.active ? 'success' : 'default'}
      muted={!procedure.active}
      dense
      metrics={[
        { label: 'Margem', value: procedure.formattedProfitMargin, tone: 'primary' },
        { label: 'Médicos', value: String(procedure.doctorsCount ?? 0) },
        { label: 'Pacotes', value: String(procedure.packagesCount ?? 0) },
        { label: 'Produtos', value: String(procedure.productsCount ?? 0) },
      ]}
      onClick={() => history.push(`/procedures/${procedure.id}`)}
    />
  );
};

export default ProcedureItemModule;
